const state = () => ({
  admin: false,
  role: [],
  ability: [],
  routes: [],
})
const getters = {
  admin: (state) => state.admin,
  role: (state) => state.role,
  ability: (state) => state.ability,
  routes: (state) => state.routes,
}
const mutations = {
  setFull(state, admin) {
    state.admin = admin
  },
  setRole(state, role) {
    state.role = role
  },
  setRoutes(state, routes) {
    state.routes = routes
  },
  setAbility(state, ability) {
    state.ability = ability
  },
}
const actions = {
  setFull({ commit }, admin) {
    commit('setFull', admin)
  },
  setRole({ commit }, role) {
    commit('setRole', role)
  },
  setRoutes({ commit }, routes) {
    commit('setRoutes', routes)
  },
  setAbility({ commit }, ability) {
    commit('setAbility', ability)
  },
  setDashboard({ commit }, auth) {
    commit('setDashboard', auth)
  },
}
export default { state, getters, mutations, actions }
